import React, { useEffect } from "react";
import { Row, Col, Button, Form, Switch, Modal as AntModal } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import Constants from "../../Utils/Constants";
import useToken from "../../Authentication/useToken";
import PropTypes from "prop-types";
import ProfessionalDetailsIdentityFields from "../shared/ProfessionalDetailsIdentityFields";

const clinicManagerDetailsFieldKeys = {
  labelFirstName: "Prénom",
  errorRequiredFirstName: "Prénom obligatoire",
  errorFirstNameMinLength: "Min 2 caractères",
  labelLastName: "Nom",
  errorRequiredLastName: "Nom obligatoire",
  errorLastNameMinLength: "Min 2 caractères",
  labelEmail: "Email",
  errorRequiredEmail: "Email obligatoire",
  errorInvalidEmailFormat: "Email invalide",
  labelPhoneNumber: "Téléphone",
  errorRequiredPhoneNumber: "Téléphone obligatoire",
  errorInvalidPhoneNumber: "Téléphone invalide",
};

function ClinicManagerDetails({ clinicManager, onClose, refetchClinicManagers }) {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const { token } = useToken();

  useEffect(() => {
    if (clinicManager) {
      setValue("firstname", clinicManager.firstname);
      setValue("lastname", clinicManager.lastname);
      setValue("email", clinicManager.email);
      setValue("phoneNumber", clinicManager.phoneNumber);
      setValue("active", clinicManager.active);
    }
  }, [clinicManager, setValue]);

  const onSubmit = (data) => {
    const payload = { ...data, role: "clinic_manager" };

    axios
      .put(`${Constants.SERVER_URL}/update-professional-user/${clinicManager.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        refetchClinicManagers();
        AntModal.success({
          content: "Gestionnaire mis à jour",
          okText: "Close",
          centered: true,
          onOk: () => onClose(),
        });
      })
      .catch((err) => {
        const backendMsg = err?.response?.data?.message;
        AntModal.error({
          content: backendMsg || "Erreur lors de la mise à jour",
          okText: "Close",
          centered: true,
        });
      });
  };

  return (
    <Row justify="center">
      <Col span={16}>
        <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
          <ProfessionalDetailsIdentityFields
            t={(k) => k}
            control={control}
            errors={errors}
            keys={clinicManagerDetailsFieldKeys}
          />

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Statut">
                <Controller
                  name="active"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <Switch
                      checked={value}
                      onChange={onChange}
                      checkedChildren="Actif"
                      unCheckedChildren="Inactif"
                    />
                  )}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Mettre à jour
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
}

ClinicManagerDetails.propTypes = {
  clinicManager: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  refetchClinicManagers: PropTypes.func.isRequired,
};

export default ClinicManagerDetails;
